import React, { useState } from "react";
import styled from "styled-components";
import Button from "../Button";
import RadioBtn from "../RadioBtn";
import { FieldGroup, TextareaGroup } from "../Input";
import axios from "axios";
import { toast } from "react-toastify";

const Report = ({ id, username, hideModal }) => {
  const [reason, setReason] = useState("");
  const [error, setError] = useState("");
  const [textArea, setTextArea] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (reason.length < 10) {
      setError("You need to report with reason!");
      return;
    }
    axios
      .post(process.env.REACT_APP_REPORT_ENDPOINT, reason, { withCredentials: true })
      .then((res) => {
        toast.success("You reported " + username);
        hideModal(false);
      })
      .catch(() => {});
  };

  const handleChange = (e, disable) => {
    if (!disable) setTextArea(false);
    setReason(e.target.value);
  };

  const handleTextArea = () => {
    setTextArea(true);
    setReason("");
  };

  return (
    <ReportStyle>
      <h2>Report {username}</h2>
      <Text>
        We are going to ask you a few questions to help us investigate your report quickly and
        accurately.
        <br />
        Where is the problem?
      </Text>
      <form onSubmit={(e) => handleSubmit(e)}>
        <RadioBtn
          value="In a live stream, video, or clip"
          name="reportReason"
          text="In a live stream, video, or clip"
          onChange={(e) => handleChange(e)}
        />
        <RadioBtn
          value="In a chat message"
          name="reportReason"
          text="In a chat message"
          onChange={(e) => handleChange(e)}
        />
        <RadioBtn
          value={"this isn 't moderatiog their chat"}
          name="reportReason"
          text={username + " isn 't moderatiog their chat"}
          onChange={(e) => handleChange(e)}
        />
        <RadioBtn
          value="Some profile content is inappropriate(Username, banner, profile...)"
          name="reportReason"
          text="Some profile content is inappropriate(Username, banner, profile...)"
          onChange={(e) => handleChange(e)}
        />
        <RadioBtn
          value="Their content is misclassified (wrong category or tags)"
          name="reportReason"
          text="Their content is misclassified (wrong category or tags)"
          onChange={(e) => handleChange(e)}
        />
        <RadioBtn value="" onClick={handleTextArea} name="reportReason" text="Somewhere else..." />
        {textArea && (
          <FieldGroup style={{ width: "95%" }} label="Tell us more">
            <TextareaGroup
              name="otherReason"
              placeholder="Further information"
              onChange={(e) => handleChange(e, true)}
            />
          </FieldGroup>
        )}
        <div>
          <Button size="small" variant="secondary" onClick={() => hideModal(false)}>
            Cancel
          </Button>
          <Button size="small" variant="primary" type="submit">
            Submit
          </Button>
        </div>
      </form>
      {error.length > 0 && <span>{error}</span>}
    </ReportStyle>
  );
};
export default Report;

const ReportStyle = styled.div`
  display: flex;
  flex-direction: column;
  h2 {
    color: ${({ theme }) => theme.color.primaryText};
    margin: 0 auto 20px auto;
  }
  form {
    margin-top: 20px;
    & > * {
      margin-bottom: 20px;
      display: block;
    }
    > div:last-child {
      display: flex;
      margin-top: 30px;
      button {
        flex: 1;
        :last-child {
          margin-left: 10px;
        }
      }
    }
  }
  > span {
    color: ${({ theme }) => theme.color.danger};
    text-align: center;
  }
`;

const Text = styled.p`
  width: 100%;
  color: ${({ theme }) => theme.color.lighterText} !important;
  width: 100%;
  margin-bottom: 6px;
  font-family: "Poppins Medium";
  color: black;
  font-weight: 600;
  font-size: 12px;
  line-height: 1.5;
`;
